module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-23.0905e927.png";